import { Meta } from '@weblite-wapps/protocol'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import hostConf from '$config/frontend'
import { generateWappElementName } from 'weblite-web-wapprunner'

export const getWappDOMElement = (meta: Meta) =>
  window.document.getElementsByName(
    generateWappElementName(meta),
  )[0] as HTMLIFrameElement

export const postMessage = (element: HTMLIFrameElement, action: unknown) =>
  element.contentWindow.postMessage(JSON.stringify(action), hostConf.WAPPS_HOST)
